import { REGISTRATION_SUBJECTS_SUCCESS, REGISTRATION_SUBJECTS_FAIL } from "../actions/action_types"

export default function quizzesReducer(state = { subjects: [], isLoading: false, error: null }, action) {
    switch (action.type) {
        case REGISTRATION_SUBJECTS_SUCCESS:
            return {...state, subjects: action.payload, isLoading: false }
        case REGISTRATION_SUBJECTS_FAIL:
            return {...state, error: action.payload, isLoading: false }
        default:
            return state
    }
}